import React from 'react';
import styled, { css } from 'styled-components';

import Media from 'css/Media';

const Html = props => {
    return(
        <Wrapper 
            content={props.content ? 1 : 0} 
            className={props.className} 
            dangerouslySetInnerHTML={{ __html: props.children }} 
        />
    )
}

export default Html;

const Wrapper = styled.div`
    ${props => props.content && css`
        p {
            ${props => props.theme.fonts.p}
            & + p {
                margin-top: ${props => props.theme.spacing.contentL};
            }
            & + h2 {
                margin-top: ${props => props.theme.spacing.elementM};

                ${Media.greaterThan('s')`
                    margin-top: ${props => props.theme.spacing.blockXS};
                `}
            }
            & + ul {
                margin-top: ${props => props.theme.spacing.contentL};
            
                ${Media.greaterThan('s')`
                    margin-top: ${props.theme.spacing.elementS};
                `}
            }
        }

        h1 {
            ${props => props.theme.fonts.h2}
            margin-bottom: ${props.theme.spacing.contentXL};
            font-weight: 500;

            ${Media.greaterThan('s')`
                margin-bottom: ${props.theme.spacing.elementS};
            `}

            + p {
                ${Media.greaterThan('m')`
                    font-size: 20px;
                    line-height: 32px;
                `}
            }
        }

        h2 {
            ${props => props.theme.fonts.p}
            font-weight: 500;
            margin-bottom: ${props.theme.spacing.contentM};
        }

        h3 {${props => props.theme.fonts.p}}

        h4 {${props => props.theme.fonts.p}}

        h5 {${props => props.theme.fonts.p}}

        h6 {${props => props.theme.fonts.p}}

        strong, b {font-weight: bold;}

        em {font-style: italic;}

        ul {
            padding-left: 20px;
            padding-inline-start: 18px;

            li {
                padding-left: 10px;
                font-size:16px;
                list-style: disc;
                ${props => props.theme.fonts.p}
                margin-bottom: 20px;

                &:last-of-type {
                    margin-bottom: 0;
                }
            }
        }
        ol {
            padding-left:20px;
            margin-bottom:20px;
            
            li {
                font-size:16px;
                margin-bottom:10px;
                list-style: decimal;
            }
        }
        a {
            color: ${props => props.theme.colors.link};
            text-decoration: underline;
            
            &:hover {
                text-decoration: none;
            }
        }

        img.alignleft {
            float:left;
            margin: 0 20px 20px 0;
        }

        img.alignright {
            float:right;
            margin: 0 0 20px 20px;
        }

        img.aligncenter {
            margin: 0 auto 20px;
        }
    `}
`